export default "__VITE_ASSET__np2FQqil__"